import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'No tengo tiempo para un devocional',
  a: 'Son 12 días, no 12 meses. Menos de 20 minutos al día es todo lo que necesitas para cambiar tu perspectiva completamente.'
}, {
  q: 'Ya leí estudios bíblicos sobre Ester',
  a: 'Este no es un estudio bíblico. Es un proceso de revelación personal. La diferencia está en que no vas a aprender sobre Ester — vas a verte en ella.'
}, {
  q: 'No sé si realmente tengo un propósito especial',
  a: 'Esa duda es exactamente por qué este devocional existe. Empiezas con esa pregunta y terminas con una respuesta que viene de adentro, no de afuera.'
}, {
  q: '¿Y si no me funciona a mí?',
  a: 'Por eso existe la garantía de 7 días. Sin riesgo, sin trámites. Solo fe.'
}, {
  q: 'He leído muchos devocionales y nada cambia',
  a: 'Porque los anteriores te daban información. Este te da un proceso. Hay una diferencia enorme entre saber y transformar.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-5 bg-navy-800/20 border-t border-gold-500/10" data-id="element-78">
      <div className="max-w-lg mx-auto" data-id="element-79">
        <h2 className="font-serif text-xl text-center text-cream-100 mb-5" data-id="element-80">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-81">
          {faqs.map((faq, index) => <div key={index} className="border border-gold-500/20 rounded-sm overflow-hidden bg-navy-900/50" data-id="element-82">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-3.5 text-left focus:outline-none" data-id="element-83">
                <span className="font-serif text-cream-200 text-[15px] pr-3 leading-snug" data-id="element-84">
                  {faq.q}
                </span>
                <ChevronDown size={16} className={`text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-85" />
              </button>

              <AnimatePresence data-id="element-86">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="p-3.5 pt-2 text-[13px] text-cream-300/70 font-light leading-relaxed border-t border-gold-500/10 mt-1" data-id="element-88">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}